import { api } from '@utils/api/api'
import { BankTransferInfo } from '@interfaces'

export const getSepaConditions = (): Promise<BankTransferInfo> => {
  return api.post('/api/v1/agree-sepa-conditions')
}
